export default "__VITE_ASSET__d92bd6ab__"